export default import.meta.ROLLDOWN_FILE_URL_wWe8hlUPVVG6fCV2ygwt0w